export const NO_LOCATION_CARD_LABEL = 'None'
